'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var toConsumableArray = require('../../external/@babel/runtime/helpers/esm/toConsumableArray.js');

var React = require('react');

var DOTS = '...';

var range = function range(start, end) {
  var length = end - start + 1;
  return Array.from({
    length: length
  }, function (_, idx) {
    return idx + start;
  });
};

var usePagination = function usePagination(currentPage, pageSize, totalPages) {
  var paginationRange = React.useMemo(function () {
    var totalPageCount = Math.ceil(totalPages / pageSize);
    var siblingCount = 2;
    var totalPageNumbers = siblingCount + 5;

    if (totalPageNumbers >= totalPageCount) {
      return range(1, totalPageCount);
    }

    var leftSiblingIndex = Math.max(currentPage - siblingCount, 1);
    var rightSiblingIndex = Math.min(currentPage + siblingCount, totalPageCount);
    var shouldShowLeftDots = leftSiblingIndex > 2;
    var shouldShowRightDots = rightSiblingIndex < totalPageCount - 2;
    var firstPageIndex = 1;
    var lastPageIndex = totalPageCount;

    if (!shouldShowLeftDots && shouldShowRightDots) {
      var leftItemCount = 5;
      var leftRange = range(1, leftItemCount);
      return [].concat(toConsumableArray['default'](leftRange), [DOTS, totalPageCount]);
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
      var rightItemCount = 5;
      var rightRange = range(totalPageCount - rightItemCount + 1, totalPageCount);
      return [firstPageIndex, DOTS].concat(toConsumableArray['default'](rightRange));
    }

    if (shouldShowLeftDots && shouldShowRightDots) {
      var middleRange = range(leftSiblingIndex, rightSiblingIndex);
      return [firstPageIndex, DOTS].concat(toConsumableArray['default'](middleRange), [DOTS, lastPageIndex]);
    }
  }, [currentPage, pageSize, totalPages]);
  return paginationRange;
};

exports.usePagination = usePagination;